import styled, { css } from 'styled-components';

export const IconContainer = styled.span<{ $color?: string }>`
  line-height: 62.5%;
  ${({ $color }) =>
    !!$color &&
    css`
      color: ${$color};
    `}
`;
